<div class="flex flex-row p-4 mt-8 justify-between items-center mb-16 xl:mb-0">

  <div (click)="goFulle()" *ngIf="!domainUser">
    <img src="assets/img/logo/logo-fulle.png" class="w-24 h-auto">
  </div>

  <div>
    <button mat-button (click)="goTerms()">
      <span class="text-md">{{'conditionsge'|translate}}</span>
    </button>
  </div>

</div>
